const saveProductsAccountsUrl = (businessKey: string): string => {
  return `/accounts/${businessKey}/account-products`;
};

export default saveProductsAccountsUrl;
